var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { Button } from '@material-ui/core';
import { useIsDesktop } from '../../../hooks';
import { useMenuOnClose } from '../hooks';
const StyledButton = styled(Button).attrs(() => ({
    underline: 'none',
})) `
  text-transform: none;
  ${({ theme }) => `
    color: ${theme.palette.primary.contrastText};
  `}
`;
const StyledLi = styled('li') `
  list-style: none;
  ${({ isDesktop }) => `
    ${StyledButton} {
      ${isDesktop
    ? ''
    : `
        padding: 8px 16px;
        width: 100%;
        justify-content: flex-start;
      `};
    }
  `}
`;
const MenuItem = (_a) => {
    var { children, forwardedRef, onClick } = _a, rest = __rest(_a, ["children", "forwardedRef", "onClick"]);
    const closeMenu = useMenuOnClose();
    const isDesktop = useIsDesktop();
    const onMobileItemClick = (e) => {
        onClick && onClick(e);
        closeMenu && closeMenu();
    };
    return (React.createElement(StyledLi, { isDesktop: isDesktop },
        React.createElement(StyledButton, Object.assign({ onClick: isDesktop ? onClick : onMobileItemClick, ref: forwardedRef }, rest), children)));
};
MenuItem.displayName = 'Navbar.MenuItem';
const MenuItemExtra = styled(forwardRef((props, ref) => (React.createElement(MenuItem, Object.assign({}, props, { forwardedRef: ref }))))) ``;
export default MenuItemExtra;
